// #1391: @web3auth/base の WEB3AUTH_NETWORK 定数はただの文字列 literal だが、
// static import すると @web3auth パッケージ群が main bundle に入る。値を
// inline してこのモジュールを @web3auth 非依存に保つ (実体の型整合は
// web3authImpl.ts の Web3Auth constructor が検査する)。
type Web3AuthNetworkType = "sapphire_mainnet" | "sapphire_devnet";

export interface NetworkConfig {
  chainId: number;
  chainIdHex: string;
  name: string;
  rpcUrl: string;
  blockExplorerUrl: string;
  ticker: string;
  tickerName: string;
  jpycAddress: string;
  jpycDecimals: number;
  web3AuthNetwork: Web3AuthNetworkType;
}

const NETWORKS: Record<string, NetworkConfig> = {
  sepolia: {
    chainId: 11155111,
    chainIdHex: "0xaa36a7",
    name: "Sepolia Testnet",
    rpcUrl: "https://ethereum-sepolia-rpc.publicnode.com",
    blockExplorerUrl: "https://sepolia.etherscan.io",
    ticker: "ETH",
    tickerName: "Ethereum",
    jpycAddress: import.meta.env.VITE_JPYC_CONTRACT_ADDRESS || "0x431D5dfF2A3B5ca39E2eAc01778af4F44798c64D",
    jpycDecimals: 18,
    web3AuthNetwork: "sapphire_devnet",
  },
  polygon: {
    chainId: 137,
    chainIdHex: "0x89",
    name: "Polygon Mainnet",
    rpcUrl: "https://polygon-bor-rpc.publicnode.com",
    blockExplorerUrl: "https://polygonscan.com",
    ticker: "POL",
    tickerName: "Polygon",
    jpycAddress: import.meta.env.VITE_JPYC_CONTRACT_ADDRESS || "0x431D5dfF03120AFA4bDf332c61A6e1766eF37BDB",
    jpycDecimals: 18,
    web3AuthNetwork: "sapphire_mainnet",
  },
};

const networkKey = import.meta.env.VITE_NETWORK || "sepolia";

// VITE_WEB3AUTH_NETWORK で Web3Authネットワークを明示的に上書き可能
// （本番環境でチェーンは sepolia のままで Web3Auth だけ sapphire_mainnet を使う場合など）
const web3authOverride = import.meta.env.VITE_WEB3AUTH_NETWORK as string | undefined;
const baseNetwork = NETWORKS[networkKey] ?? NETWORKS.sepolia;

export const NETWORK: NetworkConfig = web3authOverride
  ? {
      ...baseNetwork,
      web3AuthNetwork: (
        web3authOverride === "sapphire_mainnet"
          ? "sapphire_mainnet"
          : "sapphire_devnet"
      ),
    }
  : baseNetwork;

/** Block explorer link for a transaction hash */
export function getExplorerTxLink(txHash: string): string {
  return `${NETWORK.blockExplorerUrl}/tx/${txHash}`;
}

/** Block explorer link for an address */
export function getExplorerAddressLink(address: string): string {
  return `${NETWORK.blockExplorerUrl}/address/${address}`;
}
